module.exports = __webpack_public_path__ + "static/media/icon-right.9a7a25dd.svg";